module.exports = {
	formatBreadcrumbString: function(breadCrumbData, delimeter = '|') {
		let breadCrumbString;
		// always drop the first crumb (home)
		breadCrumbData = breadCrumbData.slice(1);
		breadCrumbString = breadCrumbData
			.map(function(crumb) {
				return crumb.name || '';
			})
			.join(delimeter);
		return breadCrumbString;
	},
	getConstructUrl: function(environment = 'local') {
		const uris = {
			production: 'https://construct.build.com',
			staging: 'https://staging-construct.build.com',
			sandbox: 'https://test-construct.build.com',
			local: 'http://localhost:4200'
		};
		return uris[environment] ? uris[environment] : uris.local;
	},
	trimProducts: function(targetProducts) {
		var trimmedProducts = targetProducts.map((product) => {
			return {
				productCompositeId: product.productCompositeId,
				manufacturer: product.manufacturer,
				productId: product.productId,
				uniqueId: product.uniqueId,
				finishes: product.finishes.map((finish) => {
					return {
						uniqueId: finish.uniqueId
					};
				}),
				selectedFinish: {
					uniqueId: product.selectedFinish.uniqueId
				}
			};
		});
		return trimmedProducts;
	}
};
